import { connect } from 'react-redux';
import {
  updateFilters,
  updateView,
  clearWorklistData,
} from '../../../worklist/containers/worklist-actions';
import TicketWorklist from '../../components/list/ticket-worklist';

const mapDispatchToProps = {
  updateFilters,
  updateView,
  clearWorklistData,
};

const mapStateToProps = state => ({
  activeFilters: state.worklist.activeFilters,
  filterDefinitions: state.worklist.filterDefinitions,
  isDataLoading: state.worklist.isDataLoading,
  menuVisible: state.header.menuVisible,
  views: state.worklist.views,
  filterGroups: state.worklist.filterGroups,
});

export default connect(mapStateToProps, mapDispatchToProps)(TicketWorklist);
